// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const InvalidDataAlert = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
